.flare-skill-management {
  box-sizing: border-box;
  height: 100%;
  overflow: auto;
  padding: 28px 32px;
  position: relative;
  width: 100%;
}

.flare-skill-management-header {
  align-items: center;
  border-bottom: 1px solid var(--flare-divider, #e5e7eb);
  display: flex;
  justify-content: space-between;
  min-height: 58px;
}

.flare-skill-management-header h2,
.flare-skill-detail-header h3,
.flare-skill-detail-section h4 {
  margin: 0;
}

.flare-skill-management-header h2 {
  font-size: 17px;
  font-weight: 500;
}

.flare-skill-management-header p {
  color: var(--flare-text-secondary, #64748b);
  font-size: 13px;
  margin: 6px 0 0;
}

.flare-skill-management-count {
  color: var(--flare-text-secondary, #64748b);
  font-size: 12px;
  white-space: nowrap;
}

.flare-skill-management-list {
  width: 100%;
}

.flare-skill-management-row {
  align-items: center;
  border-bottom: 1px solid var(--flare-divider, #e5e7eb);
  cursor: pointer;
  display: grid;
  gap: 12px;
  grid-template-columns: 32px minmax(0, 1fr) auto auto 16px;
  min-height: 58px;
  padding: 4px 8px;
}

.flare-skill-management-row:hover,
.flare-skill-management-row:focus-visible {
  background: var(--flare-hover-bg, rgba(37, 99, 235, 0.05));
  outline: none;
}

.flare-skill-management-icon {
  align-items: center;
  border: 1px solid var(--flare-divider, #dbe2ea);
  border-radius: 8px;
  display: flex;
  height: 30px;
  justify-content: center;
  width: 30px;
}

.flare-skill-management-name {
  display: block;
  font-weight: 500;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.flare-skill-management-copy {
  min-width: 0;
}

.flare-skill-management-meta {
  color: var(--flare-text-secondary, #64748b);
  display: block;
  font-size: 12px;
  margin-top: 3px;
}

.flare-skill-ownership {
  color: var(--flare-text-secondary, #64748b);
  font-size: 12px;
  white-space: nowrap;
}

.flare-skill-toggle {
  background: var(--flare-scrollbar-thumb, #cbd5e1);
  border: 0;
  border-radius: 999px;
  cursor: pointer;
  height: 21px;
  padding: 3px;
  width: 36px;
}

.flare-skill-toggle span {
  background: #fff;
  border-radius: 50%;
  display: block;
  height: 15px;
  transform: translateX(0);
  transition: transform 100ms ease;
  width: 15px;
}

.flare-skill-toggle.is-enabled {
  background: var(--flare-accent, #2563eb);
}

.flare-skill-toggle.is-enabled span {
  transform: translateX(15px);
}

.flare-skill-toggle:disabled {
  cursor: default;
  opacity: 0.55;
}

.flare-skill-management-chevron {
  color: var(--flare-text-secondary, #94a3b8);
  font-size: 11px;
}

.flare-skill-management-state,
.flare-skill-management-error {
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-height: 56px;
}

.flare-skill-management-error {
  color: var(--flare-error, #dc2626);
}

.flare-skill-icon-button {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  width: 30px;
}

.flare-skill-icon-button:hover {
  background: var(--flare-hover-bg, rgba(15, 23, 42, 0.06));
}

.flare-skill-detail {
  background: var(--flare-panel-bg, #fff);
  border-left: 1px solid var(--flare-divider, #e5e7eb);
  bottom: 0;
  box-shadow: -12px 0 28px rgba(15, 23, 42, 0.08);
  box-sizing: border-box;
  overflow: auto;
  padding: 20px;
  position: absolute;
  right: 0;
  top: 0;
  width: min(400px, 92%);
  z-index: 2;
}

.flare-skill-detail-header {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
}

.flare-skill-detail-header h3 {
  font-size: 17px;
  font-weight: 500;
  margin-top: 5px;
}

.flare-skill-detail-facts {
  border-bottom: 1px solid var(--flare-divider, #e5e7eb);
  border-top: 1px solid var(--flare-divider, #e5e7eb);
  margin: 24px 0;
  padding: 10px 0;
}

.flare-skill-detail-facts div,
.flare-skill-detail-section li {
  align-items: center;
  display: flex;
  gap: 10px;
  min-height: 38px;
}

.flare-skill-detail-facts dt {
  color: var(--flare-text-secondary, #64748b);
  width: 64px;
}

.flare-skill-detail-facts dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.flare-skill-detail-section ul {
  list-style: none;
  margin: 10px 0 0;
  padding: 0;
}

.flare-skill-detail-section li span:nth-child(2) {
  flex: 1;
}

@media (max-width: 720px) {
  .flare-skill-management {
    padding: 18px 16px;
  }
}
